import { getErrorMessage, useQuery, useShowFlag } from "@atlassiansox/microscopekit";
import { isEmpty } from "lodash";
import { WargameEnvironmentsQuery } from "../graphql";
import { useServiceId } from "./useServiceId";
export var useSupportedEnvironments = function () {
    var _a, _b, _c;
    var serviceId = useServiceId();
    var showFlag = useShowFlag();
    var _d = useQuery(WargameEnvironmentsQuery, {
        variables: {
            serviceId: serviceId
        },
        onError: function (error) {
            var errorMessage = getErrorMessage(error);
            showFlag({ type: "error", title: "Error", message: errorMessage });
        }
    }), loading = _d.loading, data = _d.data;
    var allAllowedEnvironments = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.service) === null || _a === void 0 ? void 0 : _a.micros) === null || _b === void 0 ? void 0 : _b.environments.filter(function (environment) {
        return environment.env.startsWith("stg-") ||
            environment.env.startsWith("ddev") ||
            environment.env.startsWith("adev") ||
            environment.env.startsWith("dev");
    })) !== null && _c !== void 0 ? _c : [];
    var environmentsWithValidDeployments = allAllowedEnvironments.filter(function (environment) {
        return environment.stacks.stable || environment.stacks.persistent.length;
    });
    var supportedEnvironments = !isEmpty(environmentsWithValidDeployments)
        ? environmentsWithValidDeployments
        : isBackendEnvProd()
            ? []
            : allAllowedEnvironments;
    var supportedEnvironmentNames = !isEmpty(supportedEnvironments)
        ? supportedEnvironments.map(function (environment) { return environment.env; })
        : isBackendEnvProd()
            ? []
            : FALLBACK_ALL_STAGING_ENVIRONMENTS;
    return {
        isLoading: loading,
        supportedEnvironments: supportedEnvironmentNames
    };
};
var isBackendEnvProd = function () {
    var frontendHost = window.location.hostname;
    if (frontendHost.includes("prod")) {
        return true;
    }
    return false;
};
var FALLBACK_ALL_STAGING_ENVIRONMENTS = [
    "ddev",
    "dev-west2",
    "adev",
    "adev-west2",
    "stg-east",
    "stg-west",
    "stg-west2",
    "stg-euwest",
    "stg-eucentral",
    "stg-apse",
    "stg-apse2",
    "stg-cacentral",
    "stg-eucentral2"
];
